<template>
  <div class="list-page">
    <div v-if="project && project.projectId != 'undefined'">
      <div class="layout__content__header list-page__header layout__content__header--white">
        <CopyNotification
          :opened="copyConfirmVisible"
          :text="'zkopirovanoDoSchranky'"
          @close="copyConfirmVisible = false"
        />
        <div v-if="project" class="d-flex flex-wrap mb-4 mb-sm-0 justify-content-between">
          <h1 class="mb-1 mb-sm-4">
            {{ $t("endpointy") }}
          </h1>
          <div class="list-page__buttons align-items-center d-flex d-sm-none">
            <button
              v-if="project.projectId"
              class="btn btn-primary d-flex align-items-center justify-content-center"
              @click="createNewEndpoint()"
            >
              <div class="atom-icon">
                <img src="@/assets/icons/actions/ico-btn-nova.svg" />
              </div>
              {{ $t("novyEndpoint") }}
            </button>
          </div>
        </div>
        <div v-if="project" class="d-flex justify-content-between">
          <div class="d-flex list-page__left align-items-center">
            <div
              v-if="project.projectId"
              class="custom-control custom-control--search d-flex align-items-center justify-content-between list-page__search"
            >
              <input
                id="guisearch"
                ref="searchInput"
                v-model="search"
                :placeholder="this.$t('Hledat podle názvu, ID, tagu, …')"
                autofocus
                class="w-100"
                type="text"
                @keyup.enter="searchEndpoints()"
              />
              <div v-if="search" class="atom-icon" @click="clearSearch()">
                <img src="@/assets/icons/actions/ico-close.svg" />
              </div>
              <div class="atom-icon" @click="searchEndpoints()">
                <img src="@/assets/icons/actions/ico-search-black.svg" />
              </div>
              <div class="custom-control--search__suggestions">
                <div
                  v-for="(suggestion, index) in suggestionsArray"
                  :key="index"
                  class="custom-control--search__suggestions__item"
                  @click="setSuggestion(suggestion)"
                >
                  <span>{{ suggestion }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="list-page__buttons d-none d-sm-flex align-items-center justify-content-between">
            <button
              v-if="project.projectId"
              class="btn btn-primary d-flex align-items-center justify-content-center"
              @click="createNewEndpoint()"
            >
              <div class="atom-icon">
                <img src="@/assets/icons/actions/ico-btn-nova.svg" />
              </div>
              {{ $t("novyEndpoint") }}
            </button>
          </div>
        </div>
      </div>

      <div class="layout__content__header layout__content__header--white pt-0 pb-0">
        <RadioHelp
          :article-link="'/endpoints'"
          :show="showHelp"
          @change-radio-btn-visibility="changeRadioBtnVisibility"
          @update-show-radio-help="showRadioHelp"
        />
      </div>
      <div v-if="radioSlides.length" class="detail-page__tabs__header d-flex">
        <div class="d-flex align-items-end detail-page__tabs__wrapper mt-5">
          <RadioOpenClose :radio-slides="radioSlides" :show="showHelp" @update-show-radio-help="showRadioHelp" />
        </div>
      </div>
      <div v-if="endpointsCount > 0" class="layout__content__content pt-4 pt-md-5">
        <div v-click-outside="closeDropdownActions" class="dropdown-actions">
          <button v-if="selectedRows.length > 0" class="btn btn-primary" @click="showDropdownActions()">
            <div class="d-flex align-items-center">
              {{ $t("hromadneAkce") }}
              <img class="ml-2" src="@/assets/icons/arrows/arr-down-white.svg" />
            </div>
          </button>
          <button v-else class="btn btn-primary" disabled>
            <div class="d-flex align-items-center">
              {{ $t("hromadneAkce") }}
              <img class="ml-2" src="@/assets/icons/arrows/arr-down-white.svg" />
            </div>
          </button>
          <div
            v-if="isActionsDropdownVisible && selectedRows.length > 0"
            class="dropdown-actions__wrapper dropdown-actions__wrapper--wide"
          >
            <div class="dropdown-actions__inner">
              <div class="row">
                <!--b-col cols="6" class="dropdown-actions__item d-flex align-items-center bb-0" @click="actionItems = selectedRows;toggleSideBox(1)">                 <div class="atom-icon">                   <img src="@/assets/icons/actions/ico-ico-label.svg">                 </div>                 {{ $t("pridatTag") }}               </b-col-->
                <div
                  class="dropdown-actions__item d-flex align-items-center justify-content-center justify-content-sm-start col-sm-6 col-12"
                  @click="
                    () => {
                      actionItems = selectedRows
                      toggleAddToGroupsModal('addToGroups')
                    }
                  "
                >
                  <div class="atom-icon">
                    <img src="@/assets/icons/actions/ico-ico-zmenaskupiny.svg" />
                  </div>
                  {{ $t("priraditKeSkupine") }}
                </div>
                <div
                  class="dropdown-actions__item d-flex align-items-center justify-content-center justify-content-sm-start col-sm-6 col-12"
                  @click="
                    () => {
                      actionItems = selectedRows
                      switchEndpoints(true)
                      showDropdownActions()
                    }
                  "
                >
                  <div class="atom-icon">
                    <img src="@/assets/icons/actions/ico-ico-zmenarezimu.svg" />
                  </div>
                  {{ $t("zapnout") }}
                </div>
                <div
                  class="dropdown-actions__item d-flex align-items-center justify-content-center justify-content-sm-start col-sm-6 col-12"
                  @click="
                    () => {
                      actionItems = selectedRows
                      toggleRemoveFromGroupsModal('removeFromGroups')
                    }
                  "
                >
                  <div class="atom-icon">
                    <img src="@/assets/icons/actions/ico-ico-zmenaskupiny.svg" />
                  </div>
                  {{ $t("odebratZeSkupiny") }}
                </div>
                <!--b-col cols="6" class="dropdown-actions__item d-flex align-items-center" @click="actionItems = selectedRows;toggleSideBox(1)">                 <div class="atom-icon">                   <img src="@/assets/icons/actions/ico-ico-label.svg">                 </div>                 {{ $t("odebratTag") }}               </b-col-->
                <div
                  class="dropdown-actions__item d-flex align-items-center justify-content-center justify-content-sm-start col-sm-6 col-12"
                  @click="
                    () => {
                      actionItems = selectedRows
                      switchEndpoints(false)
                      showDropdownActions()
                    }
                  "
                >
                  <div class="atom-icon">
                    <img src="@/assets/icons/actions/ico-ico-zmenarezimu.svg" />
                  </div>
                  {{ $t("vypnout") }}
                </div>
                <!--b-col cols="6" class="dropdown-actions__item d-flex align-items-center" @click="toggleSideBox(1)">                 <div class="atom-icon">                   <img src="@/assets/icons/actions/ico-ico-zprava.svg">                 </div>                 {{ $t("exportVsechZprav") }}               </b-col-->
                <div
                  class="dropdown-actions__item d-flex align-items-center bb-0 justify-content-center justify-content-sm-start col-sm-6 col-12"
                  @click="
                    () => {
                      actionItems = selectedRows
                      toggleDeleteEndpoint(selectedRows)
                      isActionsDropdownVisible = false
                    }
                  "
                >
                  <div class="atom-icon">
                    <img src="@/assets/icons/actions/ico-ico-delete-l.svg" />
                  </div>
                  {{ $t("smazatEndpoint") }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-end mb-md-4 mt-3 mt-md-0">
          <span class="font-weight-light">{{ $t("vybrano") }}: {{ selectedRows.length }}</span>
          <span v-if="selectedRows.length != sortedEndpoints.length" class="link ml-2" @click="selectAll('selectAll')">
            {{ $t("vybratVse") }}
          </span>
          <span v-if="selectedRows.length > 0" class="link ml-2" @click="selectAll('deselect')">
            {{ $t("OdvybratVse") }}
          </span>
        </div>

        <div v-if="endpointsCount > 0" class="position-relative w-100">
          <div id="endpoints" class="table-responsive">
            <table class="table table-main table-hover">
              <thead>
                <tr>
                  <th
                    v-for="(column, index) in columns"
                    :key="index"
                    :class="{ isHidden: !column.visible }"
                    :style="{ 'min-width': column.minWidth }"
                  >
                    <span v-if="column.sortable != true">
                      {{ $t(column.name) }}
                    </span>
                    <span v-else>
                      <div
                        v-if="column.name == 'custDestName'"
                        :class="{ checked: allOnPageSelected() }"
                        class="custom-control custom-control--checkbox"
                        @click="selectAll()"
                      >
                        <input class="custom-control-input" type="checkbox" />
                      </div>
                      <div class="title" @click="sortBy(column.type)">
                        {{ $t(column.name) }}
                      </div>
                      <div v-if="sort == column.type" class="sorting">
                        <span v-if="sortType == 'desc'">▼</span>
                        <span v-if="sortType == 'asc'">▲</span>
                      </div>
                    </span>
                  </th>
                  <th />
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, item_index) in sortedEndpoints" :key="item_index">
                  <td
                    v-for="(column, column_index) in columns"
                    :key="column_index"
                    :class="{
                      isHidden: !column.visible,
                      disabledEndpoint: !item.custDestEnabled,
                      'position-relative endpointName': column.type === 'custDestName'
                    }"
                    :style="{ width: column.minWidth }"
                  >
                    <span v-if="column.type === 'custDestName'" :class="{ disabledEndpoint: !item.custDestEnabled }">
                      <div
                        :class="{
                          checked: selectedRows.filter((e) => e.custDestId === item.custDestId).length > 0
                        }"
                        class="custom-control custom-control--checkbox"
                        style="display: inline-block"
                        @click="addToSelected(item)"
                      >
                        <input class="custom-control-input" type="checkbox" />
                      </div>

                      <RouterLink
                        :to="{
                          name: 'endpoint',
                          params: {
                            id: item.custDestId,
                            device: item,
                            customerId: customerId,
                            projectId: projectId
                          }
                        }"
                        class="font-weight-bolder link-gray"
                      >
                        <span :style="{ maxWidth: column.minWidth }" style="display: block; word-wrap: break-word">
                          {{ item[column.type] }}
                        </span>
                      </RouterLink>
                    </span>
                    <span v-else-if="column.type == 'custDestId'">
                      <div v-tooltip :title="item.custDestId">
                        <span class="eui-short">
                          {{ $filters.strLimitEnd(item.custDestId, 6) }}
                        </span>
                      </div>
                    </span>
                    <span v-else-if="column.type == 'protocol'">REST</span>
                    <div v-else-if="column.type == 'deviceGroups'">
                      <div
                        v-for="group in item.deviceGroups.slice(0, 1)"
                        :key="group.deviceGroupId + 'g' + item.custDestId"
                        class="d-flex"
                      >
                        <a
                          class="link-gray"
                          @click="
                            $router.push({
                              name: 'group',
                              params: { id: group.deviceGroupId, group: group }
                            })
                          "
                        >
                          <span>
                            {{ $filters.strLimit(group.deviceGroupName, 11) }}
                          </span>
                        </a>
                        <div v-if="item.deviceGroups.length > 1" class="atom-expand" @click="toggleGroup(item)">
                          <span v-if="openedGroups.indexOf(item) > -1">-</span>
                          <span v-else>+</span>
                          {{ item.deviceGroups.length - 1 }}
                        </div>
                      </div>

                      <div v-if="openedGroups.indexOf(item) > -1" class="atom-expand__content d-flex flex-wrap">
                        <div
                          v-for="group in item.deviceGroups.slice(1, item.deviceGroups.length)"
                          :key="group.deviceGroupId + 'g' + item.custDestId"
                          class=""
                        >
                          <a
                            class="link-gray"
                            @click="
                              $router.push({
                                name: 'group',
                                params: {
                                  id: group.deviceGroupId,
                                  group: group
                                }
                              })
                            "
                          >
                            <span>{{ group.deviceGroupName }}</span>
                          </a>
                        </div>
                      </div>

                      <div class="" />
                    </div>
                    <span v-else-if="column.type == 'url'">
                      <div v-tooltip :title="item.custDestParameters.url">
                        {{ $filters.strLimitEnd(item.custDestParameters.url, 36) }}
                      </div>
                      <div
                        v-if="item.custDestParameters.url"
                        class="copy d-flex align-items-center ml-1"
                        @click="copyToClipboard(item.custDestParameters.url)"
                      >
                        <img src="@/assets/icons/actions/ico-ico-copy.svg" />
                      </div>
                    </span>
                    <span v-else>{{ item[column.type] }}</span>
                  </td>
                  <td>
                    <div
                      id="kebab"
                      ref="kebab"
                      :class="{
                        opened: openedEndpoint.custDestId == item.custDestId
                      }"
                      class="kebab"
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            <table :class="{ showShadow: showShadow }" class="table table-hover fixed-first-column">
              <thead>
                <tr>
                  <th>
                    <span v-if="columns[0].sortable != true">
                      {{ $t(columns[0].name) }}
                    </span>
                    <span v-else class="d-flex align-items-center">
                      <div
                        v-if="columns[0].name == 'custDestName'"
                        :class="{
                          checked: allOnPageSelected()
                        }"
                        class="custom-control custom-control--checkbox"
                        @click="selectAll()"
                      >
                        <input class="custom-control-input" type="checkbox" />
                      </div>
                      <div class="title" @click="sortBy(columns[0].type)">
                        {{ $t(columns[0].name) }}
                      </div>
                      <div v-if="sort == columns[0].type" class="sorting">
                        <span v-if="sortType == 'desc'">▼</span>
                        <span v-if="sortType == 'asc'">▲</span>
                      </div>
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, item_index) in sortedEndpoints" :key="item_index">
                  <td
                    :class="{ disabledEndpoint: !item.custDestEnabled }"
                    :style="{ width: columns[0].minWidth }"
                    class="position-relative endpointName"
                  >
                    <span>
                      <div
                        :class="{
                          checked: selectedRows.filter((e) => e.custDestId === item.custDestId).length > 0
                        }"
                        class="custom-control custom-control--checkbox"
                        style="display: inline-block"
                        @click="addToSelected(item)"
                      >
                        <input class="custom-control-input" type="checkbox" />
                      </div>

                      <RouterLink
                        :to="{
                          name: 'endpoint',
                          params: {
                            id: item.custDestId,
                            device: item,
                            customerId: customerId,
                            projectId: projectId
                          }
                        }"
                        class="font-weight-bolder link-gray"
                      >
                        <span :style="{ maxWidth: columns[0].minWidth }" style="display: block; word-wrap: break-word">
                          {{ item.custDestName }}
                        </span>
                      </RouterLink>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>

            <table :class="{ showShadow: showShadow }" class="table table-hover fixed-last-column">
              <thead>
                <tr>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, item_index) in sortedEndpoints" :key="item_index">
                  <td>
                    <div
                      id="kebab"
                      ref="kebab"
                      :class="{
                        opened: openedEndpoint.custDestId == item.custDestId
                      }"
                      class="kebab"
                    >
                      <div class="dropdown-actions">
                        <div class="atom-icon d-block mr-0" @click="openKebab(item)">
                          <img src="@/assets/icons/menu/ico-kebab.svg" />
                        </div>
                        <div
                          v-if="openedEndpoint.custDestId == item.custDestId"
                          v-click-outside="closeKebabConf"
                          class="dropdown-actions__wrapper"
                        >
                          <div class="dropdown-actions__inner">
                            <div
                              class="dropdown-actions__item d-flex align-items-center cursor"
                              @click="actionItems = [openedEndpoint]"
                            >
                              <StateSwitcher
                                :text="true"
                                :value="openedEndpoint.custDestEnabled"
                                @switch="switchEndpoints"
                              />
                            </div>
                            <div
                              class="dropdown-actions__item d-flex align-items-center"
                              @click="
                                () => {
                                  actionItems = [openedEndpoint]
                                  toggleEditEndpointModal('editEndpoint')
                                }
                              "
                            >
                              <div class="atom-icon">
                                <img src="@/assets/icons/actions/ico-ico-upravitzarizeni.svg" />
                              </div>
                              {{ $t("upravitEndpoint") }}
                            </div>
                            <div
                              class="dropdown-actions__item d-flex align-items-center"
                              @click="
                                () => {
                                  actionItems = [openedEndpoint]
                                  ping()
                                }
                              "
                            >
                              <div class="atom-icon">
                                <img src="@/assets/icons/actions/ico-ico-ping-orange.svg" />
                              </div>
                              {{ $t("ping") }}
                            </div>
                            <div
                              class="dropdown-actions__item d-flex align-items-center"
                              cols="6"
                              @click="
                                () => {
                                  actionItems = [openedEndpoint]
                                  toggleDeleteEndpoint([openedEndpoint])
                                }
                              "
                            >
                              <div class="atom-icon">
                                <img src="@/assets/icons/actions/ico-ico-delete-l.svg" />
                              </div>
                              {{ $t("odstranitEndpoint") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-if="endpointsCount > 0" class="custom-table__footer d-flex align-items-center justify-content-between">
          <div class="custom-table__footer__actions align-items-center">
            <p class="link-gray mb-0" style="margin-right: 10px" @click="showSidebarTableColumnOrder = true">
              <span>{{ $t("upravitSloupce") }}</span>
            </p>
            <p v-if="!toggledAllRows" class="link-gray mb-0" @click="toggleAllRows()">
              <span>{{ $t("rozbalitVsechnyRadky") }}</span>
            </p>
            <p v-if="toggledAllRows" class="link-gray mb-0" @click="toggleAllRows()">
              <span>{{ $t("sbalitVsechnyRadky") }}</span>
            </p>
          </div>
          <Paging
            :page="{
              currentPage: page,
              rowsPerPage: rowsPerPage,
              itemsTotalCount: endpointsCount,
              itemsCount: allEndpoints.length
            }"
            @next-page="page++"
            @page="page = $event"
            @prev-page="page--"
            @reload-items="reloadEndpoints()"
            @rows-per-page="rowsPerPage = $event"
          />
        </div>
      </div>
      <div v-else-if="!loadingData" class="layout__content__content pt-4 pt-md-5">{{ $t("nicKZobrazeni") }}.</div>
      <div v-else class="layout__content__content pt-4 pt-md-5">
        <AppLoader />
      </div>
    </div>
    <div v-else>
      <div class="layout__content__header list-page__header">
        <div class="d-flex flex-wrap mb-4 mb-sm-0 justify-content-between">
          <h1 class="mb-1 mb-sm-4">
            {{ $t("endpointy") }}
          </h1>
        </div>
      </div>
    </div>
    <NewEndpointModal
      :opened="openedNewEndpoint"
      :tags="tags"
      protocol="HTTP"
      @close-box="closeNewEndpointModal"
      @open-box="openNextNewEndpointModal"
      @reload-items="reloadEndpoints"
    />
    <AddToGroupsModal
      :endpoints="actionItems"
      :opened="openedAddToGroups"
      :tags="tags"
      @close-box="toggleAddToGroupsModal"
      @open-box="toggleAddToGroupsModal"
      @reload-items="reloadEndpoints"
    />
    <RemoveFromGroupsModal
      :endpoints="actionItems"
      :opened="openedRemoveFromGroups"
      :tags="tags"
      @close-box="toggleRemoveFromGroupsModal"
      @open-box="toggleRemoveFromGroupsModal"
      @reload-items="reloadEndpoints"
    />
    <DeleteEndpointModal
      :centered="true"
      :items="actionItems"
      :opened="openedDeleteEndpoint"
      :text="actionItems.length > 1 ? 'endpointy' : actionItems.length > 1 ? actionItems[0].custDestName : ''"
      @close="toggleDeleteEndpoint()"
      @yes="
        () => {
          deleteEndpoint()
          toggleDeleteEndpoint()
        }
      "
    />
    <PingEndpointModal
      :centered="true"
      :items="pingResponses"
      :opened="openedPingEndpoint"
      :text="deleteText"
      @close="closePingModal"
      @repeat="pingRepeat"
    />
    <EditEndpointModal
      v-if="openedEditEndpoint.length > 0"
      :opened="openedEditEndpoint"
      :original-endpoint="actionItems[0]"
      protocol="HTTP"
      @close-box="toggleEditEndpointModal"
      @open-box="toggleEditEndpointModal"
      @reload-items="reloadEndpoints"
    />
    <TableColumnOrder
      v-if="showSidebarTableColumnOrder"
      :columns="tableColumns"
      :columns-type="columnsTypeName"
      :opened="showSidebarTableColumnOrder"
      @close-box="closeSidebarTableColumnOrder()"
    />
    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal :centered="true" :errors="errorsToTranslate" :opened="openedError" @close="openedError = false" />
    </div>
  </div>
</template>
<script>
import axios from "axios"
import _ from "lodash"
import Paging from "@/components/paging/paging.vue"
import RadioHelp from "@/components/radio/radio-help.vue"
import RadioOpenClose from "@/components/radio/radio-open-close.vue"
import NewEndpointModal from "@/components/modals/endpoints/new.vue"
import DeleteEndpointModal from "@/components/confirmations/delete.vue"
import PingEndpointModal from "@/components/confirmations/ping.vue"
import EditEndpointModal from "@/components/modals/endpoints/edit.vue"
import AddToGroupsModal from "@/components/modals/endpoints/addToGroups.vue"
import RemoveFromGroupsModal from "@/components/modals/endpoints/removeFromGroups.vue"
import TableColumnOrder from "@/components/modals/global/tableColumnOrder.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import CopyNotification from "@/components/notify/notify.vue"
import StateSwitcher from "@/components/switcher.vue"
import AppLoader from "@/components/loader.vue"
import { useProjectStore } from "@/store/modules/project"
import { useConfigStore } from "@/store/modules/config"
import { useEndpointsStore } from "@/store/modules/endpoints"

export default {
  components: {
    Paging,
    NewEndpointModal,
    RadioHelp,
    RadioOpenClose,
    DeleteEndpointModal,
    PingEndpointModal,
    EditEndpointModal,
    AddToGroupsModal,
    RemoveFromGroupsModal,
    StateSwitcher,
    ErrorModal,
    CopyNotification,
    TableColumnOrder,
    AppLoader
  },
  setup() {
    const projectStore = useProjectStore()
    const configStore = useConfigStore()
    const endpointsStore = useEndpointsStore()

    return { projectStore, configStore, endpointsStore }
  },
  data() {
    return {
      radioSlides: [],
      showHelp: true,
      tableWidth: 0,
      columns: [
        {
          type: "custDestName",
          name: "custDestName",
          sortable: true,
          visible: true,
          minWidth: "250px",
          order: 1
        },
        {
          type: "custDestId",
          name: "custDestId",
          sortable: true,
          visible: true,
          minWidth: "120px",
          order: 2
        },
        {
          type: "protocol",
          name: "protocol",
          sortable: false,
          visible: true,
          minWidth: "100px",
          order: 3
        },
        {
          type: "deviceGroups",
          name: "deviceGroups",
          sortable: false,
          visible: true,
          minWidth: "200px",
          order: 4
        },
        {
          type: "url",
          name: "url",
          sortable: false,
          visible: true,
          minWidth: "400px",
          order: 5
        },
        {
          type: "transformationLabel",
          name: "transformationLabel",
          sortable: false,
          visible: true,
          minWidth: "200px",
          order: 6
        }
      ],
      projectId: this.$route.params.projectId,
      customerId: this.$route.params.customerId,
      columnsTypeName: "columnsEndpoints",
      search: "",
      suggested: "",
      suggestionsArray: [],
      isActionsDropdownVisible: false,
      sort: "custDestName",
      sortType: "asc",
      rowsPerPage: 20,
      page: 0,
      openedRowsSelect: false,
      selectedRows: [],
      selectedAll: false,
      isSelectedAllOnPage: false,
      openedSideBox: false,
      openedEndpoint: {},
      openedGroups: [],
      openedTags: [],
      toggledAllRows: false,
      openedNewEndpoint: [],
      tags: [],
      toDelete: [],
      openedDeleteEndpoint: false,
      deleteText: "",
      pingResponses: [],
      openedPingEndpoint: false,
      openedEditEndpoint: [],
      openedAddToGroups: [],
      openedRemoveFromGroups: [],
      copyConfirmVisible: false,
      actionItems: [],
      errorsToTranslate: [],
      openedError: false,
      sortedEndpoints: [],
      loaded: true,
      loadingData: true,
      closeKebabConf: {
        handler: this.closeKebab,
        middleware: this.middlewareKebab,
        events: ["dblclick", "click"],
        isActive: true,
        detectIFrame: true,
        capture: false
      },
      tableColumnsDefault: {
        custDestId: {
          show: true,
          order: 2,
          title: "custDestId"
        },
        protocol: {
          show: true,
          order: 3,
          title: "protocol"
        },
        deviceGroups: {
          show: true,
          order: 4,
          title: "deviceGroups"
        },
        url: {
          show: true,
          order: 5,
          title: "url"
        },
        transformationLabel: {
          show: true,
          order: 6,
          title: "transformationLabel"
        }
      },
      showSidebarTableColumnOrder: false,
      tableColumns: {},
      showShadow: false
    }
  },
  computed: {
    allEndpoints() {
      return this.endpointsStore.allEndpoints
    },
    endpointsCount() {
      return this.endpointsStore.allEndpointsCount
    },
    openNewEndpointModalOnLoad() {
      return this.$store.getters["modals/ifNewEndpointVisible"]
    },
    project() {
      return this.projectStore.selectedProject
    },
    radioDisabled() {
      return this.configStore.isRadioHelpDisabled
    }
  },
  watch: {
    search() {
      if (this.suggested == "") {
        if (this.search.length > 1) {
          this.suggestions()
        }
      } else {
        this.suggested = ""
      }
    },
    project() {
      this.loadEndpoints()
      this.selectedRows = []
    },
    sort() {},
    rowsPerPage() {
      this.page = 0
      localStorage.rowsPerPage = this.rowsPerPage
    },
    page() {
      this.isSelectedAllOnPage = false
      var selectedDevices = this.allEndpoints
      let selectedDevicesId = selectedDevices.map((d) => d.custDestId)
      let selectedAllRowsArray = Array.from(this.selectedRows)
      let allEndpointsId = selectedAllRowsArray.map((d) => d.custDestId)
      this.isSelectedAllOnPage = selectedDevicesId.every((ai) => allEndpointsId.includes(ai)) ? true : false
    },
    isActionsDropdownVisible() {
      if (this.isActionsDropdownVisible) {
        this.openedEndpoint = {}
      }
    },
    radioDisabled() {
      this.showHelp = !this.radioDisabled
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.updateResponsiveTable)
      window.addEventListener("click", this.updateResponsiveTable)
    })

    this.tableColumns = this.getTableColumns()
    this.showHelp = !this.radioDisabled
    if (localStorage.rowsPerPage) {
      var rows1 = localStorage.rowsPerPage
      this.rowsPerPage = rows1
    } else {
      localStorage.rowsPerPage = this.rowsPerPage
    }
    if (this.project) {
      this.loadEndpoints()
    }
    if (this.openNewEndpointModalOnLoad) {
      this.createNewEndpoint()
      this.$store.commit("modals/setNewEndpointVisible", {
        showNewEndpoint: false
      })
    }
  },
  methods: {
    changeRadioBtnVisibility(radioSlides) {
      this.radioSlides = radioSlides
    },
    showRadioHelp(status) {
      this.showHelp = status
    },
    updateResponsiveTable() {
      this.$updateResponsiveTable(this, "endpoints")
    },
    async loadEndpoints() {
      if (
        this.$route.params.notifications &&
        this.$route.params.notifications[0] &&
        this.$route.params.notifications[0].text
      ) {
        this.$store.commit("modals/setGlobalNotification", this.$route.params.notifications)
      }

      let endpoints = await this.endpointsStore.getAllEndpoints({
        sort: this.sort,
        rowsPerPage: this.rowsPerPage,
        currentPage: this.page
      })
      if (endpoints) {
        this.loaded = true
        this.loadingData = false
        this.sortedEndpoints = this.allEndpoints
        this.$nextTick(() => {
          this.updateResponsiveTable()
        })
      }
    },
    searchEndpoints() {
      this.suggestionsArray = []
      this.sortedEndpoints = this.allEndpoints.filter(
        (endpoint) => endpoint.custDestName.toLowerCase().indexOf(this.search.toLowerCase()) !== -1
      )
    },
    reloadEndpoints() {
      this.openedNewEndpoint = []
      this.openedAddToGroups = []
      this.openedRemoveFromGroups = []
      this.loadEndpoints()
    },
    suggestions() {
      axios
        .get(
          process.env.VUE_APP_API +
            "/http/endpoints/suggestions?projectId[eq]=" +
            this.project.projectId +
            "&search=" +
            this.search +
            "*"
        )
        .then((response) => {
          this.suggestionsArray = response.data.data
        })
        .catch(() => {})
    },
    setSuggestion(suggestion) {
      this.suggested = suggestion
      this.search = suggestion
      this.searchEndpoints()
      this.suggestionsArray = []
    },
    clearSearch() {
      this.search = ""
      this.suggested = ""
      this.searchEndpoints()
    },
    showDropdownActions() {
      this.isActionsDropdownVisible = !this.isActionsDropdownVisible
    },
    sortBy(sortBy) {
      let sorted
      this.isSelectedAllOnPage = false
      this.sort = sortBy
      if (this.sortType == "asc") {
        sorted = _.orderBy(this.sortedEndpoints, `${sortBy}`, "desc")
        this.sortType = "desc"
      } else {
        sorted = _.orderBy(this.sortedEndpoints, `${sortBy}`, "asc")
        this.sortType = "asc"
      }
      this.dateChanged = false
      this.sortedEndpoints = sorted
    },
    toggleOpenedRowSelect() {
      this.openedRowsSelect = !this.openedRowsSelect
    },
    addToSelected(device) {
      if (this.selectedRows.filter((e) => e.custDestId === device.custDestId).length > 0) {
        this.selectedRows = this.selectedRows.filter((e) => e.custDestId !== device.custDestId)
      } else {
        this.selectedRows = this.selectedRows.concat([device])
      }
    },
    toggleGroup(device) {
      if (this.openedGroups.includes(device)) {
        this.openedGroups = this.openedGroups.filter((e) => e !== device)
        if (this.toggledAllRows) this.toggledAllRows = false
      } else {
        this.openedGroups = this.openedGroups.concat([device])
      }
    },
    toggleTag(device) {
      if (this.openedTags.includes(device)) {
        this.openedTags = this.openedTags.filter((e) => e !== device)
        if (this.toggledAllRows) this.toggledAllRows = false
      } else {
        this.openedTags = this.openedTags.concat([device])
      }
    },
    toggleAllRows() {
      if (this.toggledAllRows) {
        this.openedTags = []
        this.openedGroups = []
        this.toggledAllRows = false
      } else {
        this.openedTags = [].concat.apply([], this.allEndpoints)
        this.openedGroups = [].concat.apply([], this.allEndpoints)
        this.toggledAllRows = true
      }
    },
    selectAll(type) {
      this.isSelectedAllOnPage = true
      var selectedDevices = this.sortedEndpoints
      let selectedDevicesId = selectedDevices.map((d) => d.custDestId)
      let selectedAllRowsArray = Array.from(this.selectedRows)
      let allEndpointsId = selectedAllRowsArray.map((d) => d.custDestId)
      if (type === "deselect") {
        this.selectedRows = []
        this.isSelectedAllOnPage = false
      } else if (type === "selectAll") {
        this.selectedRows = [].concat.apply([], this.sortedEndpoints)
        this.isSelectedAllOnPage = true
      } else {
        if (selectedDevicesId.every((ai) => allEndpointsId.includes(ai))) {
          let indexes = []
          selectedDevices.forEach((element) => {
            indexes.push(selectedAllRowsArray.indexOf(element))
          })
          this.selectedRows.splice(indexes[0], indexes.length)
        } else {
          let indexes = []
          let same = []
          this.selectedRows.forEach((selected) => {
            let filteredArray = selectedDevices.filter((e) => e.custDestId === selected.custDestId)
            same.push(filteredArray[0])
          })
          same.forEach((element) => {
            if (element != undefined) {
              indexes.push(this.selectedRows.findIndex((obj) => obj.custDestId == element.custDestId))
            }
          })
          for (var i = indexes.length - 1; i >= 0; i--) {
            this.selectedRows.splice(indexes[i], 1)
          }
          this.selectedRows =
            this.selectedRows.length > 0
              ? this.selectedRows.concat.apply(this.selectedRows, selectedDevices)
              : [].concat.apply([], selectedDevices)
        }
      }
    },
    allOnPageSelected() {
      let itemsOnPage = this.sortedEndpoints
      let itemsOnPageId = itemsOnPage.map((d) => d.custDestId)
      let allItemsId = Array.from(this.selectedRows).map((d) => d.custDestId)
      if (itemsOnPageId.every((ai) => allItemsId.includes(ai))) {
        return true
      } else {
        return false
      }
    },
    openKebab(device) {
      this.openedEndpoint = this.openedEndpoint == device ? {} : device
    },
    closeKebab() {
      this.openedEndpoint = {}
    },
    copyToClipboard(text) {
      this.copyConfirmVisible = true
      var input = document.createElement("textarea")
      input.innerHTML = text
      document.body.appendChild(input)
      input.select()
      var result = document.execCommand("copy")
      document.body.removeChild(input)
      return result
    },
    createNewEndpoint() {
      this.openedNewEndpoint = this.openedNewEndpoint.concat(["newEndpoint"])
    },
    closeNewEndpointModal(box) {
      box == undefined
        ? (this.openedNewEndpoint = [])
        : (this.openedNewEndpoint = this.openedNewEndpoint.filter((item) => item !== box))
    },
    openNextNewEndpointModal(box) {
      this.openedNewEndpoint = this.openedNewEndpoint.concat([box])
    },
    getAllTags() {
      this.tags = _(this.allEndpoints)
        .flatMap((f) => f.tags)
        .sortedUniq()
        .value()
    },
    toggleDeleteEndpoint(items) {
      if (this.openedDeleteEndpoint == true) {
        this.openedDeleteEndpoint = false
        this.deleteText = ""
      } else {
        if (items) {
          this.deleteText = items.length > 1 ? "endpointyLabel" : items[0].custDestName
        }
        this.openedDeleteEndpoint = true
      }
    },
    deleteEndpoint() {
      this.errorsToTranslate = []
      let promises = []
      let notifications = []
      // let totalLength = this.actionItems.length;
      // var totalDone = 0;
      this.$store.commit("modals/setWaitingLoader", this.$t("Ukládám data, čekejte prosím..."))
      this.actionItems.forEach((item) => {
        let id = item.custDestId

        console.log("id to delete " + id)
        promises.push(
          axios
            .delete(process.env.VUE_APP_API + "/http/endpoints/" + id, {})
            .then(() => {
              this.selectedRows = this.selectedRows.filter(function (obj) {
                return obj.custDestId !== id
              })

              this.reloadEndpoints()
              notifications.push({
                text: "notificationEndpointDelete",
                error: false,
                params: {
                  custDestId: item.custDestId,
                  custDestName: item.custDestName
                }
              })
            })
            .catch((error) => {
              console.log("push erorr to translate")
              let message = error.data.errors[0]
              error.data.errors = []
              error.data.errors.push({
                message: message,
                attribute: {
                  custDestId: item.custDestId,
                  custDestName: item.custDestName
                }
              })
              this.errorsToTranslate.push(error.data)
            })
        )
      })

      Promise.allSettled(promises).then(() => {
        console.log("all logs are done")

        this.$store.commit("modals/setWaitingLoader", "")
        this.$store.commit("modals/setGlobalNotification", notifications)
        // this.selectedRows = [];
        this.openedError = true

        this.loadEndpoints()
      })
    },
    pingRepeat(item) {
      this.pingResponses.splice(this.pingResponses.indexOf(item), 1)
      this.ping([item])
    },
    closePingModal(item) {
      this.pingResponses.splice(this.pingResponses.indexOf(item), 1)
      if (this.pingResponses.length < 1) {
        this.openedPingEndpoint = false
      }
    },
    ping(endpoint) {
      if (this.isActionsDropdownVisible) {
        this.showDropdownActions()
      }
      let array = endpoint == undefined ? this.actionItems : endpoint
      array.forEach((item) => {
        let id = item.custDestId
        axios
          .get(process.env.VUE_APP_API + "/http/endpoints/" + id + "/ping", {})
          .then((response) => {
            let obj = { endpoint: item, response: response.data.status }
            this.pingResponses.push(obj)
            this.openedPingEndpoint = true
            this.closeKebab()
          })
          .catch((response) => {
            let obj = {
              endpoint: item,
              response: "error",
              message: response.data.errors.join(",")
            }
            this.openedPingEndpoint = true
            this.pingResponses.push(obj)
            this.closeKebab()
          })
      })
    },
    toggleEditEndpointModal(box) {
      if (this.openedEditEndpoint.includes(box)) {
        box === undefined
          ? (this.openedEditEndpoint = [])
          : this.openedEditEndpoint = this.openedEditEndpoint.filter((item) => item !== box)
        //this.selectedRows = [];
        this.selectedAll = false
      } else {
        this.openedEditEndpoint = this.openedEditEndpoint.concat([box])
      }
    },
    toggleAddToGroupsModal(box) {
      if (this.openedAddToGroups.includes(box)) {
        box == undefined
          ? (this.openedAddToGroups = [])
          : this.openedAddToGroups = this.openedAddToGroups.filter((item) => item !== box)
        this.isActionsDropdownVisible = false
      } else {
        this.openedAddToGroups = this.openedAddToGroups.concat([box])
      }
    },
    toggleRemoveFromGroupsModal(box) {
      if (this.openedRemoveFromGroups.includes(box)) {
        box == undefined
          ? (this.openedRemoveFromGroups = [])
          : this.openedRemoveFromGroups = this.openedRemoveFromGroups.filter((item) => item !== box)
        this.isActionsDropdownVisible = false
      } else {
        this.openedRemoveFromGroups = this.openedRemoveFromGroups.concat([box])
      }
    },
    switchEndpoints(value) {
      let array = this.actionItems
      this.errorsToTranslate = []
      let promises = []
      array.forEach((item) => {
        let id = item.custDestId
        item.custDestDescription = ""
        if (value == undefined) {
          item.custDestEnabled = item.custDestEnabled ? false : true
        } else {
          item.custDestEnabled = value
        }
        promises.push(
          axios
            .put(process.env.VUE_APP_API + "/http/endpoints/" + id, item, {})
            .then(() => {})
            .catch(() => {})
        )
      })
      Promise.all(promises).then(() => {
        this.openedError = true
      })
    },
    closeDropdownActions() {
      this.isActionsDropdownVisible = false
    },
    middlewareKebab(event) {
      console.log(event.target.className)
      return event.target.className !== "custom-control-label"
    },
    closeSidebarTableColumnOrder() {
      this.tableColumns = this.getTableColumns()
      console.log("this.tableColumns")
      console.log(this.tableColumns)
      this.showSidebarTableColumnOrder = false
    },
    getTableColumns() {
      const localStorageItemsJSON = localStorage.getItem(this.columnsTypeName)
      if (!localStorageItemsJSON) {
        return this.tableColumnsDefault
      }

      const localStorageItems = JSON.parse(localStorageItemsJSON)

      if (Object.keys(localStorageItems).length === 0) {
        return this.tableColumnsDefault
      }
      return localStorageItems
    }
  }
}
</script>
<style lang="scss" scoped></style>
